import React from 'react';

import { useSpaceOutlet } from '../../app/space-outlet';
import { ProjectList } from '../../features/projects/components/ProjectList';
import { SpaceLockedPlaceholder } from '../../features/billing/components/space-locked.placeholder';

export const SpaceProjectsRoute: React.FC = () => {
  const { space, isSpaceLocked } = useSpaceOutlet();

  return isSpaceLocked ? <SpaceLockedPlaceholder /> : <ProjectList space={space} />;
};
